import React from 'react'
import { Modal } from 'antd';
import iso_cert from '../../Asserts/Images/iso_certification_Img.png'

const IsoCertificationModal = ({ visible, onClose, imageUrl }) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      width={600}
    >
      <img
        src={iso_cert}
        alt="Preview"
        style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
      />
    </Modal>
  )
}

export default IsoCertificationModal
